export default __webpack_public_path__ + "static/media/record-player-open.b914ece4.png";